export const ACCESS_TOKEN_KEY = 'access-token'
export const REFRESH_TOKEN_KEY = 'refresh-token'
export const ACCESS_TOKEN_OK_KEY = `${ACCESS_TOKEN_KEY}-ok`
export const TOKEN_EXPIRATIONS = 24 * 7 // Hours (7 days)
export const ACCESS_TOKEN_EXPIRATIONS = 6 // Hours
